import type { LucideIcon } from "lucide-react";

/**
 * Sitewide flat outline icon used for benefit / feature cards.
 * No container, no gradient: a single flat colour, consistent size and stroke.
 */
export const flatIconPalette = [
  "text-amber",
  "text-sky",
  "text-lime",
  "text-brand",
  "text-violet",
  "text-navy",
] as const;

type FlatIconProps = {
  Icon: LucideIcon | React.ComponentType<{ className?: string; strokeWidth?: number }>;
  color: string;
  className?: string;
};

const FlatIcon = ({ Icon, color, className = "" }: FlatIconProps) => (
  <span className={className} aria-hidden="true">
    <Icon className={`h-[44px] w-[44px] ${color}`} strokeWidth={1.75} />
  </span>
);

export default FlatIcon;